import TableWithExpandablePanel from './component';
import SimpleTable from 'components/SimpleTable';
import Panel from './Panel';

TableWithExpandablePanel.Panel = Panel;
TableWithExpandablePanel.Header = SimpleTable.Header;
TableWithExpandablePanel.Body = SimpleTable.Body;
TableWithExpandablePanel.Row = SimpleTable.Row;
TableWithExpandablePanel.Cell = SimpleTable.Cell;

export default TableWithExpandablePanel;



// WEBPACK FOOTER //
// ./components/TableWithExpandablePanel/index.js